import { render } from "./parent-profession-radio-variant.vue?vue&type=template&id=73186a52"
import script from "./parent-profession-radio-variant.vue?vue&type=script&lang=js"
export * from "./parent-profession-radio-variant.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__